import { render, staticRenderFns } from "./resourceCenter.vue?vue&type=template&id=76933a11&scoped=true&"
import script from "./resourceCenter.vue?vue&type=script&lang=js&"
export * from "./resourceCenter.vue?vue&type=script&lang=js&"
import style0 from "./resourceCenter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./resourceCenter.vue?vue&type=style&index=1&id=76933a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76933a11",
  null
  
)

export default component.exports